

import { Component, OnInit, Renderer, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import {
  CommonUtility, Components, WpPerson, EmploymentPlan, MIN_CHAR_SEARCH_LENGTH,
  ComponentSummary, WpReferral, Task, RequestVO, EmploymentPlanCorVo
} from '../shared';
import { DateUtility, ServerConstantsService } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { DataService } from '../shared';
import { NotificationsService } from 'angular2-notifications';
import { Observable } from 'rxjs/Observable';
import { CanComponentDeactivate, CanDeactivateGuardService } from '../shared/modals/modal-popup/can-deactivate-gaurd.service';
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';

@Component({
  selector: 'app-component-details',
  templateUrl: './component-details.component.html',
  styleUrls: ['./component-details.component.scss']
})
export class ComponentDetailsComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('fileInput') fileInput: ElementRef;
  @ViewChild('headerText') headerText: ElementRef;
  @ViewChild('prevText') prevText: ElementRef;

  component: Components;
  employmentPlan: EmploymentPlan;

  ServerConstants: any;
  userActionNotificationsMap: any;
  componentMap: any;
  componentArray: any[];
  componentStatusArray: any[];
  componentStatusMap: any;

  notesSize = 0;

  minAutHrs = 0;
  maxAutHrs = 0;
  minCouHrs = 0;
  maxCouHrs = 0;

  minStartDate: NgbDateStruct;
  maxStartDate: NgbDateStruct;
  minECDate: NgbDateStruct;
  maxECDate: NgbDateStruct;

  editable: Boolean = false;
  editableTabIndex: any = '-1';
  statusTabIndex: any = '-1';
  nonEditable: Boolean = true;
  isView: Boolean = true;
  sharedData: any;
  maxAuthorizedHrsDescJson;
  maxAuthorizedHrsDescMap;
  countableHoursDescJson;
  countableHoursDescMap;
  loaderFocus:Boolean = false;
  selected:Boolean = true;

  // Elastic Search constiables
  providerSearch: string;
  elasticSuggestions = new BehaviorSubject<any>(null);
  suggestions: any = [];
  results: any = [];
  newServiceProvider;

  MIN_CHAR_SEARCH_LENGTH = MIN_CHAR_SEARCH_LENGTH;
  providerName;
  allComponentSummary;

  statusCodeDisabled = true;
  programCd;
  isChangeDetected: boolean;
  isProviderDisable = true;
  providerTabIndex: any = '-1';
  inCorrectDate = false;
  serviceError:Boolean = false;
  isCurrentEnrollment:Boolean = false;
  isReviewRecommendationPage:Boolean = false;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private rendere: Renderer,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtility: DateUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    if (this.dataService.getSharedDataObject().get('COMPS') === undefined) {
      this.router.navigate(['/task']);
    }
  }

  ngOnInit() {
    this.dataService.globalAccess = true;
    this.component = new Components();
    this.component.employmentPlan = new EmploymentPlan();
    this.sharedData = this.dataService.getSharedDataObject();

    if (this.sharedData.get('NewServerProvider') !== undefined) {
      this.newServiceProvider = this.sharedData.get('NewServerProvider');
      this.dataService.removeValueFromSharedDataMap('NewServerProvider');
    }
    if (this.sharedData.get('etEnrollment') !== null && this.sharedData.get('etEnrollment') !== undefined) {
      this.programCd = this.sharedData.get('etEnrollment').programCd;
    }
    const maxAuthorizedHrsDesc = this.data.getValueFromSharedDataMap('ComponentMaxAuthorizedHrsDesc');
    this.maxAuthorizedHrsDescJson = this.commonUtil.createNativeMapFromList(maxAuthorizedHrsDesc);
    this.maxAuthorizedHrsDescMap = this.commonUtil.createMapFromList(maxAuthorizedHrsDesc);

    const countableHoursDesc = this.data.getValueFromSharedDataMap('CountableHoursDesc');
    this.countableHoursDescJson = this.commonUtil.createNativeMapFromList(countableHoursDesc);
    this.countableHoursDescMap = this.commonUtil.createMapFromList(countableHoursDesc);
    this.data.currentMessage.subscribe(
      (message) => {

        this.parseRefTableData(message);
      });
    const providerId = this.sharedData.get('providerId');
    const providerList = this.sharedData.get('providers');
    this.providerName = providerList.get(providerId);

    this.employmentPlan = this.sharedData.get('employmentPlanForComponent');
    if(this.employmentPlan !== null && this.employmentPlan !== undefined) {
    // min date for component start date
    this.minStartDate = this.dateUtility.convertDateFromServer(this.employmentPlan.empPlanStartDt);
    // max date for component end date
    this.maxECDate = this.dateUtility.convertDateFromServer(this.employmentPlan.estimatedCompletionDt);

    // calculating max start date for component with +30 day logic
    const maxDt = new Date();
    maxDt.setMonth(this.minStartDate.month - 1);
    maxDt.setFullYear(this.minStartDate.year);
    maxDt.setDate(this.minStartDate.day);
    maxDt.setDate(maxDt.getDate() + 30);

    // calculating max start date for component with empoyment end date minus one
    const empECMinusOne = new Date();
    empECMinusOne.setMonth(this.maxECDate.month - 1);
    empECMinusOne.setFullYear(this.maxECDate.year);
    empECMinusOne.setDate(this.maxECDate.day);
    empECMinusOne.setDate(empECMinusOne.getDate() - 1);

    // Component start max date =if emp end date day is greater the +30 them set +30 else set emp end date
    if (this.dateUtility.compareDate(maxDt, empECMinusOne) === 1) {
      this.maxStartDate = this.dateUtility.convertDateFromServer(this.dateUtility.formatDate(empECMinusOne));
    } else {
      this.maxStartDate = this.dateUtility.convertDateFromServer(this.dateUtility.formatDate(maxDt));
    }
    const minDt = new Date();
    minDt.setMonth(this.minStartDate.month - 1);
    minDt.setFullYear(this.minStartDate.year);
    minDt.setDate(this.minStartDate.day + 1);
    this.minECDate = this.dateUtility.convertDateFromServer(this.dateUtility.formatDate(minDt));
  }
  
    if (this.sharedData.get('componentCd') !== undefined && this.sharedData.get('componentCd') !== null) {            
      this.loadExistingComponents();
      console.log('Selected component Code: ' + this.sharedData.get('componentCd'));
      console.log('etEnrollment ========' + this.sharedData.get('etEnrollment').id);      
      this.isReviewRecommendationPage=true;
      this.component.componentCd = this.sharedData.get('componentCd');    
      this.dataService.addValueToSharedDataMap('componentCd', null);
      this.getMaxAuthHrs();
      const stausDt = new Date();
      this.component.statusDt = this.dateUtility.convertDateFromServer(this.dateUtility.formatDate(stausDt));
      this.component.statusCd = 'AC';
      this.component.notes = '';
      console.log('this.component.componentCd - ' + this.component.componentCd);
    } else {
      this.loadPreviousComponents();
    } 
   
    this.isChangeDetected = false;   

    console.log('selectedEPForComponent= ' + this.sharedData.get('selectedEPForComponent'));
    if (this.sharedData.get('selectedEPForComponent') !== undefined && this.sharedData.get('selectedEPForComponent') !== null) {  
      if(this.sharedData.get('selectedEPForComponent').includes("Prior")) {
        this.isCurrentEnrollment = false;
      } else {
        this.isCurrentEnrollment = true;
      }

      console.log('!isCurrentEnrollment: ' + !this.isCurrentEnrollment);
    }
  }

  elasticSearch(searchQuery, results) {
    this.elasticSuggestions.next(null);

    this.suggestions = [];
    this.http.post(this.ServerConstants.SERVER_API_URL + '/service-provider/get-all-providers/', {text: searchQuery}).subscribe(
      (val) => {
        results.next(val);
      },
      response => {
        this.notificationService.error('Component Details', this.userActionNotificationsMap.ERROR);
        results.next(null);
      }
    );
  }


  loadEditComponent(comp) {
    // Adding if condition to fix issue displaying the same component when navigating from overall progress page
    if (comp !== null && comp !== undefined && comp.id !== undefined && comp.id > 0) {
      this.component = comp;
    } else {
      this.component = Object.assign({}, this.sharedData.get('componentObject'));
    }
    this.notesSize = this.component.notes.length;
    this.providerSearch = this.component.serviceProviderName;
    this.component.startDt = this.dateUtility.convertDateFromServer(this.component.startDt);
    this.component.statusDt = this.dateUtility.convertDateFromServer(this.component.statusDt);
    this.component.estimatedCompletionDt = this.dateUtility.convertDateFromServer(this.component.estimatedCompletionDt);
    this.maxAutHrs = Number(this.maxAuthorizedHrsDescJson[this.component.componentCd]);
    if (this.newServiceProvider !== undefined) {
      this.providerSearch = this.newServiceProvider;
    }

    if (this.component.statusCd === 'JR') {
      this.editable = true;
      this.editableTabIndex = '0';
      this.statusTabIndex = '0';
      this.isView = false;
    } else {
      this.editable = false;
      this.editableTabIndex = '-1';
      this.statusTabIndex = '-1';
    }
    this.statusCodeDisabled = false;
    this.statusTabIndex = '-1';
  }

  // getSuggestions() {
  //   this.elasticSuggestions.next(null);
  //   this.suggestions = []
  //   if (this.providerSearch.length >= this.MIN_CHAR_SEARCH_LENGTH) {
  //     this.elasticSearch(this.providerSearch, this.elasticSuggestions);
  //     this.elasticSuggestions.subscribe((value) => {
  //       this.suggestions = [];
  //       if (value !== null && value.length > 0) {
  //         value.forEach(element => {
  //           this.suggestions.push(element);
  //         });
  //         // const index = value.findIndex(x => x.name.toLowerCase() === this.providerSearch.toLowerCase());
  //         // if (index === -1) {
  //         //   this.isProviderDisable = false;
  //         // } else {
  //         //   this.isProviderDisable = true;
  //         // }
  //         this.isProviderDisable = true;
  //         this.providerTabIndex = '0';
  //       } else {
  //         this.isProviderDisable = false;
  //         this.providerTabIndex = '-1';
  //       }
  //     });
  //   } else {
  //     this.isProviderDisable = true;
  //     this.providerTabIndex = '0';
  //     if (this.providerName !== undefined) {
  //       this.suggestions.push({ name: this.providerName });
  //     }
  //   }
  // }


  // autoCompleteResultClick(result) {
  //   this.providerSearch = result.name;
  //   this.suggestions = [];
  //   this.elasticSuggestions.next(null);
  // }

  getSuggestions(event) {
    this.selected = false;
    this.loaderFocus = true;
    this.suggestions = [];
    this.elasticSuggestions.next(null);
    if (this.providerSearch.length >= MIN_CHAR_SEARCH_LENGTH) {
      event.srcElement.blur();
      event.preventDefault();
      this.elasticSearch(this.providerSearch, this.elasticSuggestions);
      this.elasticSuggestions.subscribe((value) => {
        this.suggestions = [];
        if (value !== null && value.length > 0) {
          value.forEach(element => {
            this.suggestions.push(element);
          });
          this.suggestions.sort(this.commonUtil.sortObjectsByStringProperty('name'));
          this.isProviderDisable = true;

        } else {
          this.isProviderDisable = false;
        }
      });
    } else {
      this.suggestions = [];
    }
  }

  autoCompleteResultClick(result) {
    this.selected = true;
    this.serviceError = false;
    this.providerSearch = result.name;
    this.suggestions = [];
    this.elasticSuggestions.next(null);
  }

  loadExistingComponents() {
    const request = new ComponentSummary();
    if (this.employmentPlan !== undefined && this.employmentPlan.id !== undefined && this.employmentPlan.id > 0) {
      request.employment_plan_id = this.employmentPlan.id;
    
    request.start_dt = this.employmentPlan.empPlanStartDt;
    request.end_dt = this.employmentPlan.estimatedCompletionDt;

    this.http.post<ComponentSummary>(this.ServerConstants.SERVER_API_URL + '/component/load', request).subscribe(
      (data: ComponentSummary) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('ComponentDetails Summary', this.userActionNotificationsMap.ERROR);
        } else {
          if (data != null) {
            if (data.component.length > 0) {
              this.allComponentSummary = data.component;

            } else {
              this.allComponentSummary = [];
            }
            const editComponent = this.sharedData.get('componentObject');
            console.log('editComponent =====  ' + editComponent);            
          }
        }

      }, response => {

      }, () => {

      });
    }
  }


  loadPreviousComponents() {
    const request = new ComponentSummary();
    if (this.employmentPlan !== undefined && this.employmentPlan.id !== undefined && this.employmentPlan.id > 0) {
      request.employment_plan_id = this.employmentPlan.id;
    }
    request.start_dt = this.employmentPlan.empPlanStartDt;
    request.end_dt = this.employmentPlan.estimatedCompletionDt;

    this.http.post<ComponentSummary>(this.ServerConstants.SERVER_API_URL + '/component/load', request).subscribe(
      (data: ComponentSummary) => {
        if (data.hasOwnProperty('errorCode')) {
          this.notificationService.error('ComponentDetails Summary', this.userActionNotificationsMap.ERROR);
        } else {
          if (data != null) {
            if (data.component.length > 0) {
              this.allComponentSummary = data.component;

            } else {
              this.allComponentSummary = [];

            }
            const editComponent = this.sharedData.get('componentObject');
            if (editComponent !== undefined && editComponent.id !== undefined
              && this.employmentPlan !== undefined && this.employmentPlan.id !== undefined) {
              this.component = editComponent;
              this.loadEditComponent(null);
            } else {
              const overallComponentId = this.sharedData.get('overall-component-id');
              if (overallComponentId !== undefined && overallComponentId > 0) {
                this.dataService.removeValueFromSharedDataMap('overall-component-id');
                this.allComponentSummary.forEach(element => {
                  if (element.id === Number(overallComponentId)) {
                    this.component = element;
                    this.employmentPlan = this.component.employmentPlan;
                    // removing below line and passing component parameter to fix issue displaying the same component when navigating from overall progress page
                    // this.dataService.addValueToSharedDataMap('componentObject', this.component);
                    this.loadEditComponent(this.component);
                  }
                });
              } else {

                this.component.employmentPlan = new EmploymentPlan();

                this.loadNewComponentDetails();
              }

            }

          }
        }

      }, response => {

      }, () => {

      });
  }


  calculateCountableHrs() {

    this.component.countableHours = this.countableHoursDescJson[this.component.componentCd] * Number(this.component.authorizedHours);

  }

  getMaxAuthHrs() {
    this.maxAutHrs = Number(this.maxAuthorizedHrsDescJson[this.component.componentCd]);
    this.calculateCountableHrs();
  }

  loadNewComponentDetails() {
    this.component = Object.assign({}, new Components());
    this.providerSearch = '';
    this.component.employmentPlan = this.employmentPlan;
    const stausDt = new Date();
    this.component.statusDt = this.dateUtility.convertDateFromServer(this.dateUtility.formatDate(stausDt));
    this.component.statusCd = 'AC';
    this.component.notes = '';
    this.statusCodeDisabled = true;
    this.statusTabIndex = '0';

  }



  public onQuickTextChanged($event) {
    this.notesSize = this.component.notes.length;
  }

  statusDataChanges() {
    const stausDt = new Date();
    this.component.statusDt = this.dateUtility.convertDateFromServer(this.dateUtility.formatDate(stausDt));
  }

  dataChanges() {
    this.isChangeDetected = true;
  }

  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if (this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }

  }

  parseRefTableData(myData) {
    if (myData !== undefined && myData.englishDropDown) {
      this.componentArray = myData.englishDropDown['COMPONENTS'];
      this.componentMap = this.commonUtil.createMapFromList(this.componentArray);
      this.componentStatusArray = myData.englishDropDown['COMPONENT_STATUS'];
      this.componentStatusMap = this.commonUtil.createMapFromList(this.componentStatusArray);
      this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(myData.englishDropDown['USER-ACTION-NOTIFICATIONS']);
    }
  }
  validAptDate() {
    console.log(this.component.startDt);
    if (this.component.startDt !== undefined) {
      const minDt = new Date();
      minDt.setMonth(this.component.startDt.month - 1);
      minDt.setFullYear(this.component.startDt.year);
      minDt.setDate(this.component.startDt.day + 1);
      this.minECDate = this.dateUtility.convertDateFromServer(this.dateUtility.formatDate(minDt));

    }
  }
  focus() {
    setTimeout(() => this.fileInput.nativeElement.focus(), 0);
    this.fileInput.nativeElement.click();
  }
  focusHeader(event) {
    if (event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.headerText.nativeElement.focus(), 0);
    }
    if (event.shiftKey && event.keyCode === 9) {
      event.preventDefault();
      setTimeout(() => this.prevText.nativeElement.focus(), 0);
    }
  }
  // Below conditin will through an error if estimated complition date is less than the start date
  // checkEndDate() {
  //   const formattedStartDate = new Date(this.dateUtility.convertDateForServer(this.component.startDt));
  //   const formattedEndDate = new Date(this.dateUtility.convertDateForServer(this.component.estimatedCompletionDt));
  //   const calculatedValue = this.dateUtility.compareDate(formattedStartDate, formattedEndDate);
  //   if (calculatedValue === 1 || calculatedValue === 0) {
  //     this.inCorrectDate = true;
  //   } else {
  //     this.inCorrectDate = false;
  //   }
  // }
  save() {    
    if(this.selected !== true){
      this.serviceError = true;
    }
    else{
    this.isChangeDetected = false;
    const newComponent = this.component;
    let flag = true;
    const componentList = ['JS', 'JT']; // 'Job Club'', or ''Employment Counseling' missing in reference table
    const nStartDt = new Date(this.dateUtility.convertDateForServer(newComponent.startDt));
    const nEndDt = new Date(this.dateUtility.convertDateForServer(newComponent.estimatedCompletionDt));
    if (newComponent.componentCd === 'JR' && this.dateUtility.getDaysBetweenDates(nStartDt, nEndDt) > 90) {
      this.notificationService.warn('Component Details', 'Maximum number of days the client can have Job Retention is 90 calendar days');
      flag = false;
      }


    if (flag && this.allComponentSummary !== undefined && this.allComponentSummary.length > 0) {
      let jobHours = newComponent.countableHours;
      let totalHours = newComponent.countableHours;

      let conjunctionFlag = false;
      const conjunctionList = ['OT', 'VT', 'BS', 'AS', 'WE'];
      // for each existing component records check against new component record
      this.allComponentSummary.forEach(existingComponent => {

        if (flag && existingComponent.id !== newComponent.id) {
          const exStartDt = existingComponent.startDt;
          const exEndDt = existingComponent.estimatedCompletionDt;

          const today = new Date();
          const exStartMonth = this.dateUtility.convertDateFromServer(existingComponent.startDt).month;
          const exEndMonth = this.dateUtility.convertDateFromServer(existingComponent.estimatedCompletionDt).month;

          // 1. If user attempts to create a Component that has the same name as a 
          // Component already saved to the Employment Plan in which the time frame overlaps - 
          // ''There is already an active component with the same Component Name that overlaps.
          //  Please check Component Name or adjust the Start Date and Anticipated End Date''

          if (newComponent.componentCd === existingComponent.componentCd) {
            if ((this.dateUtility.compareDate(nStartDt, exStartDt) < 0 && this.dateUtility.compareDate(nEndDt, exStartDt) < 0)
              || (this.dateUtility.compareDate(nStartDt, exEndDt) > 0 && this.dateUtility.compareDate(nEndDt, exEndDt) > 0)) {
              flag = true;
            } else {
              this.notificationService.warn('Component Details',
                'There is already an active component with the same Component Name that overlaps. Please check Component Name or adjust the Start Date and Anticipated End Date');
              flag = false;
            }

          }


          // 3.  The maximum countable hours across multiple components cannot exceed 120 hours per month
          if (newComponent.startDt.month === exStartMonth || newComponent.startDt.month === exEndMonth) {
            totalHours = totalHours + existingComponent.countableHours;
            if (totalHours > 120) {
              this.notificationService.warn('Component Details',
                'The maximum countable hours for all components cannot exceed 120 hours per month');
              flag = false;
            }
          }
          if (componentList.includes(newComponent.componentCd)) {
            if (conjunctionList.includes(existingComponent.componentCd)) {
              conjunctionFlag = true;
            }
          } else {
            conjunctionFlag = true;
          }


          // this code used to check for existing Job Retention
          if (existingComponent.componentCd === 'JR') {
            if ((this.dateUtility.compareDate(nStartDt, exStartDt) < 0 && this.dateUtility.compareDate(nEndDt, exStartDt) < 0)
              || (this.dateUtility.compareDate(nStartDt, exEndDt) > 0 && this.dateUtility.compareDate(nEndDt, exEndDt) > 0)) {
              flag = true;
            } else {
              this.notificationService.warn('Component Details',
                this.componentMap.get(newComponent.componentCd) + ' and Job Retention is not allowed to be assigned at the same time');
              flag = false;

            }
          }

          switch (newComponent.componentCd) {

            // Job Retention shall not allow other Components to be assigned at the same time.
            // compareDate(date1,date2) if date1<date2 ==>-1 date1>date2 ==>1 date1==date2 ==>0
            case 'JR':
              if ((this.dateUtility.compareDate(nStartDt, exStartDt) < 0 && this.dateUtility.compareDate(nEndDt, exStartDt) < 0)
                || (this.dateUtility.compareDate(nStartDt, exEndDt) > 0 && this.dateUtility.compareDate(nEndDt, exEndDt) > 0)) {
                flag = true;
              } else {
                this.notificationService.warn('Component Details',
                  'Job Retention is not allowed with other Components to be assigned at the same time');
                flag = false;
                break;
              }
              break;

            // 2.  Independent Job Search and Job Search Training can be assigned at the same time, however,
            // the total maximum hours for the combined Components cannot exceed the calculated  hours of 39 hours per month.
            case 'JS':
              if ('JT' === existingComponent.componentCd || 'JS' === existingComponent.componentCd) {
                if (newComponent.startDt.month === exStartMonth || newComponent.startDt.month === exEndMonth) {
                  jobHours = jobHours + existingComponent.countableHours;
                  if (jobHours > 39) {
                    this.notificationService.warn('Component Details',
                      'The Independent Job Search hours exceed the number of countable hours when combined with Job Search Training');
                    flag = false;
                    break;
                  }

                }
              }
              break;
            case 'JT':
              if ('JT' === existingComponent.componentCd || 'JS' === existingComponent.componentCd) {
                if (newComponent.startDt.month === exStartMonth || newComponent.startDt.month === exEndMonth) {
                  jobHours = jobHours + existingComponent.countableHours;
                  if (jobHours > 39) {
                    this.notificationService.warn('Component Details',
                      'The Job Search Training calculated hours exceed the number of countable hours when combined with Independent Job Search');
                    flag = false;
                    break;
                  }

                }
              }
              break;


          }
        } else {
          if (this.allComponentSummary.length === 1) {
            if (componentList.includes(newComponent.componentCd)) {
              conjunctionFlag = false;

            } else {
              conjunctionFlag = true;
            }
          }
        }

      });
      if (flag && !conjunctionFlag) {
        this.notificationService.warn('Component Details', this.componentMap.get(newComponent.componentCd)
          + ' is required conjunction component.');

      }
    } else if (componentList.includes(newComponent.componentCd)) {
      this.notificationService.warn('Component Details', this.componentMap.get(newComponent.componentCd)
        + ' is required conjunction component.');

    }


    if (flag) {
      const copyComponent = Object.assign({}, newComponent);
      copyComponent.estimatedCompletionDt = this.dateUtility.convertDateForServer(this.component.estimatedCompletionDt);
      copyComponent.startDt = this.dateUtility.convertDateForServer(this.component.startDt);
      copyComponent.statusDt = this.dateUtility.convertDateForServer(this.component.statusDt);
      copyComponent.estimatedCompletionDt = this.dateUtility.convertDateForServer(this.component.estimatedCompletionDt);
      copyComponent.serviceProviderName = this.providerSearch;




      const referralId = this.sharedData.get('referralId');
      const providerId = this.sharedData.get('providerId');
      let personId = 0;
      if (this.sharedData.get('wpPersonId') !== null && this.sharedData.get('wpPersonId') !== undefined) {
        personId = Number(this.sharedData.get('wpPersonId'));
      }

      let indicator = 'C';
      let assignedTo = 0;
      if (providerId > 0) {
        assignedTo = providerId;
        indicator = 'P';
      } else {
        const personProvider = this.sharedData.get('personProvider');
        if (personProvider !== undefined && personProvider != null && personProvider.id !== undefined) {

          assignedTo = personProvider.id.serviceCounty;

        }
      }



      const wpPerson = new WpPerson();
      wpPerson.id = personId;
      const wpReferral = new WpReferral();
      wpReferral.id = Number(referralId);

      const oldTask = new Task();

      oldTask.assignedTo = String(assignedTo);
      oldTask.assignedToInd = indicator;
      oldTask.taskType = 'CM';
      oldTask.wpReferral = wpReferral;
      oldTask.wpPerson = wpPerson;

      const newTask = Object.assign({}, oldTask);
      newTask.taskType = 'MT';
      newTask.programCd = this.programCd;
      const requestVO = new ComponentRequest(this.isReviewRecommendationPage, this.sharedData.get('etEnrollment').id, copyComponent, newTask, oldTask);

      this.http.post<Components>(this.ServerConstants.SERVER_API_URL + '/component/save', requestVO)
        .subscribe(
          (res: Components) => {
            if (res.hasOwnProperty('errorCode')) {
              this.notificationService.error('System Error:Please contact Help Desk', this.userActionNotificationsMap.ERROR);
            } else {
              this.component = res;
              this.router.navigate(['task/componentSummary']);
              this.notificationService.success('Component saved successfully', this.userActionNotificationsMap.UPDATE);
              this.addTrackComponent();
              setTimeout(() => this.headerText.nativeElement.focus(), 0);
            }
          },
          (response) => {
            this.notificationService.error('System Error:Please contact Help Desk', this.userActionNotificationsMap.ERROR);
          },
          () => {
          });
    }
  }
  }
  addServiceProvider() {
    this.router.navigate(['task/componentSummary/serviceProvider']);
  }
  addTrackComponent(){
    this.http.get(this.ServerConstants.CITIZEN_API_URL+"/update/" + Number(this.sharedData.get('wpPersonId'))).subscribe((data)=>{
      if(data["message"]=="success"){
        this.notificationService.success('Component', "Added track Components");
      }
      else{
        this.notificationService.error('Component', "Unable to Add track Components");
      }
    },error=>{
      this.notificationService.error('Component', "Unable to Add track Components");
    })
  }
  reset() {
    if (this.component !== undefined
      && this.component.id !== undefined
      && this.employmentPlan !== undefined
      && this.employmentPlan.id !== undefined) {

      this.loadEditComponent(null);
    } else {
      this.loadNewComponentDetails();

    }
    this.serviceError = false;
  }

}


class ComponentRequest {
  constructor(public addRecommendedComponent: Boolean, public enrollmentId: number, public mainObject: any, public newTask?: Task, public oldTask?: Task, public employmentPlanCorVo?: EmploymentPlanCorVo)  {
  }
}



// WEBPACK FOOTER //
// ./src/app/component-details/component-details.component.ts